import React from 'react';
import { Container, Row, Col, Image, Card } from 'react-bootstrap';

const CompanyProfilePage = () => {
  return (
    <>
      {/* 1. Introductory Section (Banner/Header) */}
      <div className="bg-light text-center py-5">
        <Container>
          <h1 className="display-4 font-weight-bold">About Friends-Tech Corporation</h1>
          <p className="lead text-muted">A Commitment to Excellence in Textile Solutions.</p>
        </Container>
      </div>

      {/* 2. Main Content Split Section */}
      <Container className="my-5">
        <Row className="align-items-start">
          
          {/* Left Column: Image and Text Block */}
          <Col md={6} className="mb-4 mb-md-0">

              <h3 className="text-primary mb-3">About Us</h3>
              <p className="text-justify">
               Established in 2022, Friends-Tech Corporation has rapidly emerged as one of the most competent and well-established agencies for textile machinery, accessories, and spare parts in Bangladesh.
               Better known for our unwavering commitment to customer satisfaction, we operate under the “FIRST” Principle — delivering First-class products and services with integrity, reliability, and innovation.
               As a trusted agent and industry leader, Friends-Tech Corporation plays a vital role in supporting the modernization of the textile industry in Bangladesh. Our primary focus is on providing high-quality digital textile printing machinery, sublimation equipment, and advanced textile finishing solutions, sourced from leading manufacturers—especially from China, where cutting-edge technology meets cost-efficiency.

              </p>
                     {/* Mission/Vision Text Block */}
            <h3 className="text-primary mb-3">Our Strengths</h3>
            <p className="text-justify">
             •	Established Expertise: With a strong foundation since 2022, we understand the evolving needs of the textile industry.
            •	Global Sourcing: We bring the latest innovations in textile technology from international markets.
            •	Comprehensive Solutions: Beyond product supply, we offer professional technical and non-technical support tailored to client needs.
            •	Client-Centric Philosophy: We work closely with our partners to ensure they receive the best possible solutions — both in performance and value.

            </p>
            {/* Mission/Vision Text Block */}
            <h3 className="text-primary mb-3">Our Mission & Vision</h3>
            <p className="text-justify">
              To be the preferred technology partner for Bangladesh’s textile industry by offering premium products, dependable services, and continuous innovation.
             </p>
              <p className="text-justify">
              To empower the textile sector in Bangladesh with world-class machinery and support, driving efficiency, creativity, and long-term sustainability.
             </p>
          </Col>

          {/* Right Column: Key Details, Team, and Stats */}
          <Col md={6}>
            
            {/* The "CEO/Team" Section */}
            <Card className="shadow-sm mb-4">
                <Card.Body>
                    <h4 className="text-dark">Our Core Offerings</h4>
                    <p className="font-italic mb-2">• Digital Textile Printing Machines</p>
                    <p className="font-italic mb-2">•	Sublimation Printing </p>
                    <p className="font-italic mb-2">•	Textile pre, post & Finishing Chemicals</p>
                    <p className="font-italic mb-2">•	Textile Accessories & Spare Parts</p>
                    <p className="font-italic mb-2">•	New Textile Technologies & Solutions</p>
                </Card.Body>
            </Card>

            {/* Statistics/Fact Boxes */}
            <Row className="mt-4">
                <Col xs={6} className="mb-3">
                    <div className="text-center p-3 bg-light rounded border">
                        <h2 className="text-info font-weight-bold">3+</h2>
                        <p className="mb-0 text-muted">Years of Experience</p>
                    </div>
                </Col>
                <Col xs={6} className="mb-3">
                    <div className="text-center p-3 bg-light rounded border">
                        <h2 className="text-info font-weight-bold">300+</h2>
                        <p className="mb-0 text-muted">Successful Installations</p>
                    </div>
                </Col>
                <Col xs={6} className="mb-3">
                    <div className="text-center p-3 bg-light rounded border">
                        <h2 className="text-info font-weight-bold">24/7</h2>
                        <p className="mb-0 text-muted">Customer Support</p>
                    </div>
                </Col>
                <Col xs={6} className="mb-3">
                    <div className="text-center p-3 bg-light rounded border">
                        <h2 className="text-info font-weight-bold">Top</h2>
                        <p className="mb-0 text-muted">Industry Brands</p>
                    </div>
                </Col>
            </Row>

          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CompanyProfilePage;